import React, { ReactNode } from 'react'
import styles from './heading.module.scss'
type As = 'h1' | 'h2' | 'h3'
const Heading = ({ as, children }: { as?: As, children: ReactNode }) => {
	return (
		<h1 className={styles.h1}>
			{children}
		</h1>
	)
}

export default Heading